import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AlertMessageService } from '@sigepe/sigepe-template';

export class Param {
    nome: string;
    valor: any;
    constructor(nome: string, valor: any) {
        this.nome = nome;
        this.valor = valor;
    }
}

@Injectable({
    providedIn: 'root'
})
/**
 * Superclasse dos serviços REST do Férias
 */
export abstract class ConsultaRESTBaseService {
    private baseURL = environment.local ? '/api' : environment.production ? environment.barramentoServicoFerias : environment.barramentoServicoFerias + '/api';

    private debugEnabled = environment.production ? false : true;
    alertaMsgService: AlertMessageService;
    http: HttpClient;

    constructor(alertaMsgService: AlertMessageService, http: HttpClient) {
        console.debug('>>new [environment.local? ' + environment.local + ', environment.barramentoServicoFerias?' + environment.barramentoServicoFerias + ']');
        this.alertaMsgService = alertaMsgService;
        this.http = http;
    }

    public getBlob(url: string, params?: Param[], httpHeaders?: HttpHeaders): Observable<any> {
        let httpParams = new HttpParams();
        if (typeof params !== 'undefined') {
            for (const param of params) {
                httpParams = httpParams.append(param.nome, param.valor);
            }
        }
        if (this.debugEnabled) {
            console.debug(`>>getBlob [${this.baseURL}/${url}, params?'${httpParams}, httpHeaders?: ${httpHeaders}`);
        }
        const retorno = this.http
            .get(this.baseURL + url, {
                params: httpParams,
                headers: httpHeaders,
                responseType: 'blob'
            })
            .pipe(
                catchError(error => {
                    throw error;
                })
            );
        return retorno;
    }

    public get(url: string, params?: Param[], httpHeaders?: HttpHeaders): Observable<any> {
        let httpParams = new HttpParams();
        if (typeof params !== 'undefined') {
            for (const param of params) {
                httpParams = httpParams.append(param.nome, param.valor);
            }
        }
        if (this.debugEnabled) {
            console.debug(`>>get [${this.baseURL}/${url}, params?'${httpParams}, httpHeaders?: ${httpHeaders}`);
        }
        const retorno = this.http
            .get(this.baseURL + url, {
                params: httpParams,
                headers: httpHeaders
            })
            .pipe(
                catchError(error => {
                    throw error;
                })
            );
        return retorno;
    }

    public post(url: string, body: any, httpHeaders?: HttpHeaders): Observable<any> {
        if (this.debugEnabled) {
            console.debug(`>>post [${this.baseURL}/${url}, body='${body}`);
        }
        const retorno = this.http.post<any>(this.baseURL + url, body, { headers: httpHeaders }).pipe(
            catchError(error => {
                throw error;
            })
        );
        return retorno;
    }

    public put(url: string, body?: any, httpHeaders?: HttpHeaders): Observable<any> {
        if (this.debugEnabled) {
            console.debug(`>>put [${this.baseURL}/${url}, body='${body}`);
        }
        const retorno = this.http.put<any>(this.baseURL + url, body, { headers: httpHeaders }).pipe(
            catchError(error => {
                throw error;
            })
        );
        return retorno;
    }

    public delete(url: string, httpHeaders?: HttpHeaders): Observable<any> {
        if (this.debugEnabled) {
            console.debug(`>>delete [${this.baseURL}/${url}`);
        }
        const retorno = this.http.delete<any>(this.baseURL + url, { headers: httpHeaders }).pipe(
            catchError(error => {
                throw error;
            })
        );
        return retorno;
    }

    public transformObjecttoParamArray(object: any): Param[] {
        const params: Param[] = [];

        for (const prop in object) {
            if (Object.prototype.hasOwnProperty.call(object, prop)) {
                if (object[prop] !== null && object[prop] !== undefined) {
                    params.push({
                        nome: prop,
                        valor: object[prop]
                    });
                }
            }
        }

        return params;
    }
}
